var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.75C4.5 8.5125 5.0025 7.3875 5.82 6.57L4.755 5.505C3.675 6.5925 3 8.0925 3 9.75C3 12.81 5.2875 15.33 8.25 15.6975V14.1825C6.1275 13.8225 4.5 11.9775 4.5 9.75ZM15 9.75C15 6.435 12.315 3.75 9 3.75C8.955 3.75 8.91 3.7575 8.865 3.7575L9.6825 2.94L8.625 1.875L6 4.5L8.625 7.125L9.6825 6.0675L8.8725 5.2575C8.9175 5.2575 8.9625 5.25 9 5.25C11.4825 5.25 13.5 7.2675 13.5 9.75C13.5 11.9775 11.8725 13.8225 9.75 14.1825V15.6975C12.7125 15.33 15 12.81 15 9.75Z",
    fill: "#354052"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReset);
export default __webpack_public_path__ + "static/media/ic-reset.50eead1440fd3c261b4ba49ae9f72506.svg";
export { ForwardRef as ReactComponent };